import { Switch, Route, BrowserRouter as Router } from 'react-router-dom'

import { ScratchCard, MultipleChoicePage } from '~/pages'

const routes = () => (
  <Router>
    <Switch>
      <Route exact path="/:slug/:contractNumber">
        {/* <ScratchCard /> */}
        <MultipleChoicePage />
      </Route>
    </Switch>
  </Router>
)

export default routes
